import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Assurance, Assure, Avenant, Compagnie, Conducteur, Collaborateur, GarantieI, Site, Vehicule } from '../../shared/model';
import { DatabaseConnection } from '../../shared/services/database-connection';

interface AvenantCheckI{
  assurance : Assurance,
  assure : Assure,
  collaborateur : Collaborateur,
  site : Site,
  conducteur : Conducteur,
  vehicule : Vehicule,
  compagnie : Compagnie,
  garanties : GarantieI[],
  reduction : number,
  offline : boolean,
  vehicules : Vehicule[],
}

@Injectable({
  providedIn: 'root',
})
export class AvenantService {
  constructor(
    private http : HttpClient,
    private  dbConnection : DatabaseConnection
  ){

  }

  checkAssurance(ref : string){
    return this.http.get<AvenantCheckI>(this.dbConnection.remoteApiConnection.value + 'find-assurance?ref='+ref)
  }

  loadOfflineAssurance(assurance_id : string){
    return this.http.get<AvenantCheckI>(this.dbConnection.remoteApiConnection.value + 'load-offline-assurance/'+assurance_id)
  }

  saveAvenant(data : any){
    return this.http.post<{result : any, police : string}>(this.dbConnection.remoteApiConnection.value + 'avenant', data)
  }
}
